export { default } from './Paper';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Paper/index.js
// module id = 98
// module chunks = 121